import { Injectable, signal } from '@angular/core';

export interface AlertState {
  message: string;
  title?: string;
  type?: 'error' | 'info' | 'success';
}

@Injectable({
  providedIn: 'root'
})
export class GlobalAlertService {
  readonly alertState = signal<AlertState | null>(null);

  showError(message: string, title: string = 'Something went wrong') {
    this.alertState.set({ message, title, type: 'error' });
  }
  
  showInfo(message: string, title: string = 'Notice') {
    this.alertState.set({ message, title, type: 'info' });
  }

  showSuccess(message: string, title: string = 'Success') {
    this.alertState.set({ message, title, type: 'success' });
  }

  clearAlert() {
    this.alertState.set(null);
  }
}
